"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[244],{

/***/ 56475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ StyledAccordionSummary; },
/* harmony export */   "s": function() { return /* binding */ StyledAccordion; }
/* harmony export */ });
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99608);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97753);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68956);


var StyledAccordionSummary = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            minHeight: 20,
            maxHeight: 20,
            backgroundColor: "#f0f0f0",
            "&.Mui-expanded": {
                minHeight: 20,
                maxHeight: 20,
                backgroundColor: "#f0f0f0"
            }
        },
        expandIcon: {
            order: -1
        }
    };
})(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
var StyledAccordion = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            borderBottom: "1px solid grey",
            boxShadow: "none"
        }
    };
})(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);


/***/ }),

/***/ 92957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GalleryTabSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57389);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92750);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95017);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21849);
/* harmony import */ var react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32746);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56530);
/* harmony import */ var _AppState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66791);
/* harmony import */ var _utils_materialsLib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46116);
/* harmony import */ var _utils_uploadsLib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62260);
/* harmony import */ var _utils_shared_business__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54834);
/* harmony import */ var _ProcessingIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25170);














var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        tab: {
            display: "inline-block",
            width: "auto",
            position: "relative"
        },
        selectorText: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            cursor: "pointer",
            color: "#aaa",
            marginRight: theme.spacing(3),
            marginBottom: theme.spacing(4),
            fontWeight: "thick",
            letterSpacing: "-0.03em",
            "&:hover": {
                color: theme.palette.primary.light
            }
        }, theme.breakpoints.down("xs"), {
            fontSize: "1.4em",
            marginRight: theme.spacing(1.5)
        }),
        selectorTextFinal: {
            marginRight: theme.spacing(0)
        },
        currentLink: {
            color: "".concat(theme.palette.primary.main, " !important"),
            textDecoration: "underline",
            textDecorationThickness: "15%",
            textUnderlineOffset: "50%"
        },
        flex: {
            display: "flex"
        },
        processingIcon: (_obj = {
            marginTop: theme.spacing(-0.75)
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("xs"), {
            marginLeft: theme.spacing(0.5)
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("xs"), {
            marginLeft: 0
        }), _obj),
        sectionDesktop: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            display: "none"
        }, theme.breakpoints.up("sm"), {
            display: "flex"
        }),
        sectionMobile: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            display: "flex"
        }, theme.breakpoints.up("sm"), {
            display: "none"
        }),
        decoratorText: {
            cursor: "pointer",
            position: "absolute",
            top: "-10px",
            left: "1px",
            margin: 0,
            color: theme.palette.primary.main,
            fontSize: "0.7em",
            fontWeight: "bold"
        }
    };
});
function GalleryTabSelector(props) {
    var current = props.current;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppState__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .I), galleryUser = ref.galleryUser, qaDisplay = ref.qaDisplay, importAvailable = ref.importAvailable, setRedirect = ref.setRedirect;
    var classes = useStyles();
    var classesThis = "".concat(classes.selectorText, " ").concat(classes.currentLink);
    var classesOther = "".concat(classes.selectorText);
    var classesThisFinal = "".concat(classes.selectorText, " ").concat(classes.currentLink, " ").concat(classes.selectorTextFinal);
    var classesOtherFinal = "".concat(classes.selectorText, " ").concat(classes.selectorTextFinal);
    // We reduce the number of API fetch calls by sharing the same cache key as useMaterials() on in status.js.
    var processingMaterialsCount = (0,_utils_materialsLib__WEBPACK_IMPORTED_MODULE_5__/* .useMaterials */ .ft)(galleryUser, null, _utils_materialsLib__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_DAYS_SINCE */ .af, true, qaDisplay, false, 60000).processingMaterialsCount;
    // We reduce the number of API fetch calls by sharing the same cache key as useUploads() on in status.js.
    var uploadsPending = (0,_utils_uploadsLib__WEBPACK_IMPORTED_MODULE_6__/* .useUploads */ .x)(galleryUser, null, _utils_materialsLib__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_DAYS_SINCE */ .af, true, 60000).uploadsPending;
    var allowImport = qaDisplay ? true : importAvailable; // Remains null if unset, e.g. while still loading
    function clickImport(importAllowed) {
        return _clickImport.apply(this, arguments);
    }
    function _clickImport() {
        _clickImport = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(importAllowed) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!importAllowed) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            navIfNotCurrent("/import")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_3__/* ["default"].track */ .Z.track("View Landing Page", {
                            page: "import"
                        });
                        window.open(_utils_shared_business__WEBPACK_IMPORTED_MODULE_7__/* .importLandingPage */ .Py, "_blank");
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _clickImport.apply(this, arguments);
    }
    function navIfNotCurrent(target) {
        return _navIfNotCurrent.apply(this, arguments);
    }
    function _navIfNotCurrent() {
        _navIfNotCurrent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(target) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                if (!target.includes(current)) {
                    setRedirect(target);
                }
                return [
                    2
                ];
            });
        });
        return _navIfNotCurrent.apply(this, arguments);
    }
    // Keyboard shortcuts for tab navigation
    (0,react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_2__/* .useHotkeys */ .y1)("alt+l", function() {
        navIfNotCurrent("/home");
    });
    (0,react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_2__/* .useHotkeys */ .y1)("alt+n", function() {
        navIfNotCurrent("/upload");
    });
    (0,react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_2__/* .useHotkeys */ .y1)("alt+i", function() {
        clickImport(allowImport);
    });
    (0,react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_2__/* .useHotkeys */ .y1)("alt+p", function() {
        navIfNotCurrent("/status");
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.flex,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            container: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    item: true,
                    className: classes.tab,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "h3",
                        className: current == "home" ? classesThis : classesOther,
                        onClick: function() {
                            return navIfNotCurrent("/home");
                        },
                        children: "Library"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    item: true,
                    className: classes.tab,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "h3",
                        className: current == "upload" ? classesThis : classesOther,
                        onClick: function() {
                            return navIfNotCurrent("/upload");
                        },
                        children: "Scan"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    item: true,
                    className: classes.tab,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "h3",
                        className: current == "import" ? classesThis : classesOther,
                        onClick: function() {
                            return clickImport(allowImport);
                        },
                        children: "Import"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    item: true,
                    className: classes.tab,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "h3",
                        className: current == "status" ? classesThisFinal : classesOtherFinal,
                        onClick: function() {
                            return navIfNotCurrent("/status");
                        },
                        children: [
                            "Processing",
                            (processingMaterialsCount > 0 || uploadsPending > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classes.processingIcon,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProcessingIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 88570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gc": function() { return /* binding */ UploadMethod; },
  "W4": function() { return /* binding */ UploadMethodNames; },
  "ZP": function() { return /* binding */ components_PhotoUpload; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9970);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(15767);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@uppy+core@3.13.1/node_modules/@uppy/core/lib/Uppy.js + 7 modules
var Uppy = __webpack_require__(73189);
// EXTERNAL MODULE: ./node_modules/.pnpm/@uppy+react@3.4.0_@uppy+core@3.13.1_@uppy+dashboard@3.9.1_@uppy+core@3.13.1__@uppy+drag_b10ab02101d71cb6a5703f69d075981d/node_modules/@uppy/react/lib/index.js + 105 modules
var lib = __webpack_require__(32579);
// EXTERNAL MODULE: ./node_modules/.pnpm/@uppy+aws-s3@3.6.2_@uppy+core@3.13.1/node_modules/@uppy/aws-s3/lib/index.js + 30 modules
var aws_s3_lib = __webpack_require__(26676);
// EXTERNAL MODULE: ./node_modules/.pnpm/@uppy+core@3.13.1/node_modules/@uppy/core/dist/style.css
var style = __webpack_require__(77088);
// EXTERNAL MODULE: ./node_modules/.pnpm/@uppy+dashboard@3.9.1_@uppy+core@3.13.1/node_modules/@uppy/dashboard/dist/style.css
var dist_style = __webpack_require__(24387);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(19644);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(30277);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Tabs/Tabs.js + 5 modules
var Tabs = __webpack_require__(2733);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(49634);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(27245);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(92750);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(95017);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(26482);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(19324);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(74098);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(65116);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(64741);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(21849);
// EXTERNAL MODULE: ./node_modules/.pnpm/mixpanel-browser@2.65.0/node_modules/mixpanel-browser/dist/mixpanel.module.js
var mixpanel_module = __webpack_require__(56530);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0._1eabfd1ab4a38dfa9c512b11ff12a5ca/node_modules/@material-ui/icons/ComputerSharp.js
var ComputerSharp = __webpack_require__(20924);
// EXTERNAL MODULE: ./components/Icons.js + 1 modules
var Icons = __webpack_require__(755);
// EXTERNAL MODULE: ./utils/axiosApi.js + 3 modules
var axiosApi = __webpack_require__(86156);
// EXTERNAL MODULE: ./utils/errorLib.js + 94 modules
var errorLib = __webpack_require__(27497);
// EXTERNAL MODULE: ./utils/hooksLib.js
var hooksLib = __webpack_require__(10114);
;// CONCATENATED MODULE: ./utils/validationLib.js
function isValidWeTransferLink(link) {
    var url = URL.canParse(link) ? new URL(link) : null;
    if (url && url.protocol === "https:") {
        if (url.href.startsWith("https://we.tl/t-")) return true;
        if ((url.host === "wetransfer.com" || url.host.endsWith(".wetransfer.com")) && url.pathname.startsWith("/downloads/")) return true;
    }
    return false;
}
// Check whether the given user can upload scans via the provided sourceUrl on S3
function isValidS3Link(user, sourceUrl) {
    var ref;
    return sourceUrl && (user === null || user === void 0 ? void 0 : (ref = user.uploadPaths) === null || ref === void 0 ? void 0 : ref.some(function(path) {
        return sourceUrl.startsWith(path);
    }));
}
function isValidS3BucketLink(user, sourceUrl) {
    var ref;
    return sourceUrl && (user === null || user === void 0 ? void 0 : (ref = user.uploadPaths) === null || ref === void 0 ? void 0 : ref.some(function(path) {
        if (sourceUrl.startsWith(path)) {
            var parts = sourceUrl.split("/");
            if (parts.length == 3 || parts.length == 4 && parts[3] === "") {
                return true;
            }
        } else {
            return false;
        }
    }));
}
function isValidS3PathLink(user, sourceUrl) {
    var ref;
    return sourceUrl && (user === null || user === void 0 ? void 0 : (ref = user.uploadPaths) === null || ref === void 0 ? void 0 : ref.some(function(path) {
        if (sourceUrl.startsWith(path)) {
            var parts = sourceUrl.split("/");
            if (parts.length >= 4 && parts[3] !== "") {
                return true;
            }
        } else {
            return false;
        }
    }));
}

// EXTERNAL MODULE: ./utils/useAuth.js + 6 modules
var useAuth = __webpack_require__(74216);
// EXTERNAL MODULE: ./utils/shared/formatLib.js
var formatLib = __webpack_require__(71028);
// EXTERNAL MODULE: ./utils/shared/metadataLib.js
var metadataLib = __webpack_require__(81283);
// EXTERNAL MODULE: ./components/AppState.js + 1 modules
var AppState = __webpack_require__(66791);
// EXTERNAL MODULE: ./components/TabPanel.js
var TabPanel = __webpack_require__(27419);
;// CONCATENATED MODULE: ./components/PhotoUpload.js




























var allowedFileTypes = metadataLib/* ScanTypeFileExtensions */.lR;
var tabHeight = "48px";
var UploadMethod = Object.freeze({
    UPPY: 0,
    WE_TRANSFER: 1,
    S3: 2
});
var UploadMethodNames = Object.freeze({
    UPPY: "Uppy",
    WE_TRANSFER: "WeTransfer",
    S3: "S3"
});
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        captionDiv: {
            fontSize: "0.8em",
            color: "#777",
            textAlign: "left"
        },
        captionEmailText: {
            color: theme.palette.secondary.main,
            cursor: "pointer",
            marginLeft: theme.spacing(0.5),
            textAlign: "center",
            textDecoration: "none",
            "&:hover": {
                color: "#003fff"
            }
        },
        uploadPanel: {
            marginTop: "1em",
            marginBottom: "1em",
            marginLeft: "0.5em"
        },
        tabs: {
            backgroundColor: theme.palette.accent.main,
            boxShadow: "none"
        },
        indicator: {
        },
        tab: {
            height: tabHeight,
            minWidth: 100
        },
        textureTypes: {
            display: "flex",
            alignItems: "center"
        },
        textureTypesHeadings: {
            marginBottom: "1em"
        },
        filename: {
            wordWrap: "break-word"
        },
        errorMargin: {
            marginTop: theme.spacing(5)
        }
    };
});
var USE_MULTIPART_PLUGIN = true;
function PhotoUpload(props) {
    var scanType = props.scanType, userId = props.userId, userItem = props.userItem, materialId = props.materialId, setMaterialId = props.setMaterialId, setUploadComplete = props.setUploadComplete, name = props.name, setName = props.setName, setPhotos = props.setPhotos, originalPhotos = props.originalPhotos, setOriginalPhotos = props.setOriginalPhotos, importFilenames = props.importFilenames, setImportFilenames = props.setImportFilenames, updateImportFilenames = props.updateImportFilenames, duplicateMapTypes = props.duplicateMapTypes, mapTypeErrors = props.mapTypeErrors, onUploading = props.onUploading, uploadMethod = props.uploadMethod, setUploadMethod = props.setUploadMethod, uploadLinks = props.uploadLinks, setUploadLinks = props.setUploadLinks;
    var ref = (0,axiosApi/* useAxios */.b)(), apiGet = ref.apiGet, apiPost = ref.apiPost, apiDelete = ref.apiDelete;
    var classes = useStyles();
    var showAlert = (0,react.useContext)(AppState/* AppContext */.I).showAlert;
    var isAuthenticated = (0,useAuth/* useAuth */.a)().isAuthenticated;
    var filesAddedCount = (0,react.useRef)(0);
    var ref1 = (0,react.useState)([]), filesCompleted = ref1[0], setFilesCompleted = ref1[1];
    var ref2 = (0,react.useState)(false), hasUppyUploadStarted = ref2[0], setHasUppyUploadStarted = ref2[1];
    var ref3 = (0,react.useState)(false), uppyUploadComplete = ref3[0], setUppyUploadComplete = ref3[1];
    var ref4 = (0,react.useState)(false), uploadPathsLoaded = ref4[0], setUploadPathsLoaded = ref4[1];
    var ref5 = (0,react.useState)(false), processWholeBucket = ref5[0], setProcessWholeBucket = ref5[1];
    //
    // Uppy uploader
    //
    var ref6 = (0,react.useState)(function() {
        return new Uppy/* default */.Z({
            id: scanType
        })// shouldUseMultipart must be set during the initial use() call.
        .use(aws_s3_lib/* default */.Z, {
            shouldUseMultipart: USE_MULTIPART_PLUGIN
        });
    }), uppy = ref6[0];
    var onFileAddedEvent = (0,hooksLib/* useStableCallback */.R9)(function(file) {
        if (scanType === metadataLib/* ScanType.TEXTURE_IMPORT */.pv.TEXTURE_IMPORT) {
            var ref = (0,_sliced_to_array/* default */.Z)((0,formatLib/* textureTypeFromFilename */.td)(file.data.name), 2), mapType = ref[0], prefix = ref[1];
            setImportFilenames(function(param) {
                var items = param.items;
                return {
                    items: items.set(file.data.name, mapType)
                };
            });
            if (!name) {
                setName(prefix);
            }
        }
    }, [
        scanType,
        setImportFilenames
    ]);
    var onFileRemovedEvent = (0,hooksLib/* useStableCallback */.R9)(function(file, reason) {
        if (scanType === metadataLib/* ScanType.TEXTURE_IMPORT */.pv.TEXTURE_IMPORT) {
            setImportFilenames(function(param) {
                var items = param.items;
                items.delete(file.data.name);
                return {
                    items: items
                };
            });
            setFilesCompleted(function(oldFiles) {
                return oldFiles.filter(function(_, i) {
                    var ref;
                    return ((ref = originalPhotos[i]) === null || ref === void 0 ? void 0 : ref.name) !== file.data.name;
                });
            });
            setPhotos(function(oldPhotos) {
                return oldPhotos.filter(function(_, i) {
                    var ref;
                    return ((ref = originalPhotos[i]) === null || ref === void 0 ? void 0 : ref.name) !== file.data.name;
                });
            });
            setOriginalPhotos(function(oldOriginalPhotos) {
                return oldOriginalPhotos.filter(function(op) {
                    return op.name !== file.data.name;
                });
            });
        }
    }, [
        scanType,
        setImportFilenames,
        originalPhotos,
        setFilesCompleted,
        setPhotos,
        setOriginalPhotos
    ]);
    var onUploadEvent = (0,hooksLib/* useStableCallback */.R9)(function(data) {
        console.debug("Starting photo upload ".concat(data.id, " for user ").concat(userId, " with files ").concat(data.fileIDs));
        mixpanel_module/* default.track */.Z.track("Start Scan Upload", {
            "Material ID": materialId,
            "Scan Type": scanType,
            "Upload Method": UploadMethodNames.UPPY,
            "Upload ID": data.id,
            "Photos": data.fileIDs.length
        });
        setUppyUploadComplete(false);
        setHasUppyUploadStarted(true);
        if (onUploading) {
            onUploading(true);
        }
    }, [
        onUploading,
        userId
    ]);
    var onUploadSuccessEvent = (0,hooksLib/* useStableCallback */.R9)(function(file, response) {
        //console.debug('adding completed photo:', file.name);
        var ix = null; // Index to replace, if any
        if (originalPhotos && originalPhotos.filter(function(op) {
            return op.name === file.data.name;
        }).length > 0) {
            console.log("Upload filename already present, replacing: ", file.data.name);
            ix = originalPhotos.findIndex(function(op) {
                return op.name === file.data.name;
            });
        }
        setFilesCompleted(function(oldFiles) {
            return (0,_to_consumable_array/* default */.Z)(oldFiles.filter(function(_v, i) {
                return i !== ix;
            })).concat([
                file.name, 
            ]);
        });
        setPhotos(function(oldPhotos) {
            return (0,_to_consumable_array/* default */.Z)(oldPhotos.filter(function(_v, i) {
                return i !== ix;
            })).concat([
                file.name, 
            ]);
        });
        setOriginalPhotos(function(oldOriginalPhotos) {
            return (0,_to_consumable_array/* default */.Z)(oldOriginalPhotos.filter(function(_v, i) {
                return i !== ix;
            })).concat([
                {
                    name: file.data.name,
                    relativePath: file.data.relativePath
                }, 
            ]);
        });
    }, [
        setFilesCompleted,
        originalPhotos,
        setOriginalPhotos,
        setPhotos
    ]);
    var onCompleteEvent = (0,hooksLib/* useStableCallback */.R9)(function(result) {
        mixpanel_module/* default.track */.Z.track("Complete Scan Upload", {
            "Material ID": materialId,
            "Scan Type": scanType,
            "Upload Method": UploadMethodNames.UPPY,
            "Succeeded Count": filesCompleted.length,
            "Failed Count": result.failed.length,
            "Succeeded Size Total MB": filesCompleted.reduce(function(n, param) {
                var size = param.size;
                return n + size;
            }, 0) / 1e6,
            "Failed Size Total MB": result.failed.reduce(function(n, param) {
                var size = param.size;
                return n + size;
            }, 0) / 1e6
        });
        console.debug("upload complete");
        console.debug("successful files:", filesCompleted);
        console.debug("failed files:", result.failed);
        setUppyUploadComplete(true);
    }, [
        filesCompleted
    ]);
    // AWS S3 standard callbacks for Uppy
    var getUploadParameters = (0,hooksLib/* useStableCallback */.R9)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, param) {
            var signal, ref, response, e, _data, method, url, fields, headers;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = param.signal;
                        console.assert(materialId, JSON.stringify({
                            materialId: materialId,
                            message: "materialId should be truthy"
                        }));
                        response = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            apiPost("/upload", {
                                filename: file.name,
                                scanType: scanType
                            }, {
                                params: {
                                    userId: userId,
                                    materialId: materialId
                                },
                                signal: signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,errorLib/* onError */.q)(e);
                        throw e;
                    case 4:
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "success") {
                            _data = response.data.data, method = _data.method, url = _data.url, fields = _data.fields;
                            headers = {
                                "Content-Type": file.type
                            }; // Content type header required by S3
                            return [
                                2,
                                {
                                    method: method,
                                    url: url,
                                    fields: fields,
                                    headers: headers
                                }
                            ];
                        } else {
                            showAlert({
                                status: "error",
                                message: "An error occurred during upload"
                            });
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, _) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiPost,
        materialId,
        scanType,
        showAlert,
        userId
    ]);
    // AWS S3 multipart callbacks for Uppy
    var createMultipartUpload = (0,hooksLib/* useStableCallback */.R9)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, signal) {
            var ref, response, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.assert(materialId, JSON.stringify({
                            materialId: materialId,
                            message: "materialId should be truthy"
                        }));
                        response = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            apiPost("/companion/s3/multipart", {
                                filename: file.name,
                                type: file.type,
                                metadata: {}
                            }, {
                                params: {
                                    userId: userId,
                                    materialId: materialId
                                },
                                signal: signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,errorLib/* onError */.q)(e);
                        throw e;
                    case 4:
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "success") {
                            return [
                                2,
                                response.data.data
                            ];
                        } else {
                            showAlert({
                                status: "error",
                                message: "An error occurred during upload"
                            });
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiPost,
        materialId,
        showAlert,
        userId
    ]);
    var listParts = (0,hooksLib/* useStableCallback */.R9)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, param, signal) {
            var uploadId, key, ref, response, uploadIdEnc, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        uploadId = param.uploadId, key = param.key;
                        console.assert(materialId, JSON.stringify({
                            materialId: materialId,
                            message: "materialId should be truthy"
                        }));
                        response = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        uploadIdEnc = encodeURIComponent(uploadId);
                        return [
                            4,
                            apiGet("/companion/s3/multipart/".concat(uploadIdEnc), {
                                params: {
                                    userId: userId,
                                    materialId: materialId,
                                    key: key
                                },
                                signal: signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,errorLib/* onError */.q)(e);
                        throw e;
                    case 4:
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "success") {
                            return [
                                2,
                                response.data.data
                            ];
                        } else {
                            showAlert({
                                status: "error",
                                message: "An error occurred during upload"
                            });
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, _, signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiGet,
        materialId,
        showAlert,
        userId
    ]);
    var signPart = (0,hooksLib/* useStableCallback */.R9)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, param) {
            var uploadId, key, partNumber, signal, ref, response, uploadIdEnc, partNumberEnc, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        uploadId = param.uploadId, key = param.key, partNumber = param.partNumber, signal = param.signal;
                        console.assert(materialId, JSON.stringify({
                            materialId: materialId,
                            message: "materialId should be truthy"
                        }));
                        response = {};
                        uploadIdEnc = encodeURIComponent(uploadId);
                        partNumberEnc = encodeURIComponent(partNumber);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            apiGet("/companion/s3/multipart/".concat(uploadIdEnc, "/").concat(partNumberEnc), {
                                params: {
                                    userId: userId,
                                    materialId: materialId,
                                    key: key
                                },
                                signal: signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,errorLib/* onError */.q)(e);
                        throw e;
                    case 4:
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "success") {
                            return [
                                2,
                                response.data.data
                            ];
                        } else {
                            showAlert({
                                status: "error",
                                message: "An error occurred during upload"
                            });
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, _) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiGet,
        materialId,
        showAlert,
        userId
    ]);
    var abortMultipartUpload = (0,hooksLib/* useStableCallback */.R9)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, param, signal) {
            var key, uploadId, ref, response, uploadIdEnc, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = param.key, uploadId = param.uploadId;
                        console.assert(materialId, JSON.stringify({
                            materialId: materialId,
                            message: "materialId should be truthy"
                        }));
                        response = {};
                        uploadIdEnc = encodeURIComponent(uploadId);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            apiDelete("/companion/s3/multipart/".concat(uploadIdEnc), {
                                params: {
                                    userId: userId,
                                    materialId: materialId,
                                    key: key
                                },
                                signal: signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,errorLib/* onError */.q)(e);
                        throw e;
                    case 4:
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "success") {
                            return [
                                2,
                                response.data.data
                            ];
                        } else {
                            showAlert({
                                status: "error",
                                message: "An error occurred during upload"
                            });
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, _, signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiDelete,
        materialId,
        showAlert,
        userId
    ]);
    var completeMultipartUpload = (0,hooksLib/* useStableCallback */.R9)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, param, signal) {
            var key, uploadId, parts, ref, response, uploadIdEnc, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = param.key, uploadId = param.uploadId, parts = param.parts;
                        console.assert(materialId, JSON.stringify({
                            materialId: materialId,
                            message: "materialId should be truthy"
                        }));
                        response = {};
                        uploadIdEnc = encodeURIComponent(uploadId);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            apiPost("/companion/s3/multipart/".concat(uploadIdEnc, "/complete"), {
                                parts: parts
                            }, {
                                params: {
                                    userId: userId,
                                    materialId: materialId,
                                    key: key
                                },
                                signal: signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,errorLib/* onError */.q)(e);
                        throw e;
                    case 4:
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "success") {
                            return [
                                2,
                                response.data.data
                            ];
                        } else {
                            showAlert({
                                status: "error",
                                message: "An error occurred during upload"
                            });
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, _, signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiPost,
        materialId,
        showAlert,
        userId
    ]);
    var restrictions = {
        allowedFileTypes: allowedFileTypes[scanType]
    };
    if (scanType === metadataLib/* ScanType.TEXTURE_IMPORT */.pv.TEXTURE_IMPORT) {
        restrictions.maxNumberOfFiles = formatLib/* TextureTypes.size */.hj.size;
    }
    (0,react.useEffect)(function() {
        uppy.setOptions({
            onBeforeFileAdded: function(currentFile, files) {
                // Check if a file with the same content has already been added.
                // This is the same check that Uppy does by default, but we need to do it explicitly when we use our
                // own handler.
                if (Object.hasOwn(files, currentFile.id)) {
                    console.debug("File ID for ".concat(currentFile.name, " is already in the upload list"));
                    uppy.log("File ID for ".concat(currentFile.name, " is already in the upload list"), "warn");
                    // No need to show an info message here, because Uppy already does that.
                    return false;
                }
                // Check if a file with the same name has already been added. In principle we can handle this but
                // currently the UI for selecting texture types doesn't support it.
                var filenames = Object.values(files).map(function(file) {
                    return file.data.name;
                });
                if (filenames.includes(currentFile.name)) {
                    console.debug("File name ".concat(currentFile.name, " is already in the upload list"));
                    uppy.log("File name ".concat(currentFile.name, " is already in the upload list"), "warn");
                    uppy.info("Cannot add the file '".concat(currentFile.name, "', name already exists"), "warn", 5000);
                    return false;
                }
                var cleanFilename = (0,formatLib/* makeCleanFilename */.jo)(currentFile.name);
                var ref = (0,_sliced_to_array/* default */.Z)((0,formatLib/* splitExt */.LQ)(cleanFilename), 2), root = ref[0], ext = ref[1];
                // We assume this incrementing logic is safe from race conditions, because the calling function inside
                // Uppy modifies the files object after our callback returns which implies that Uppy has considered
                // and prevented race condition in this code path.
                filesAddedCount.current += 1;
                var currentFileIndex = filesAddedCount.current - 1;
                var modifiedFilename = "".concat(root, "__").concat(String(currentFileIndex).padStart(3, "0")).concat(ext);
                var modifiedFile = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFile), {
                    name: modifiedFilename
                });
                return modifiedFile;
            },
            restrictions: restrictions
        });
        // When shouldUseMultipart is set to true, the AwsS3 plugin renames itself to AwsS3Multipart.
        uppy.getPlugin("AwsS3Multipart").setOptions({
            getUploadParameters: getUploadParameters,
            createMultipartUpload: createMultipartUpload,
            listParts: listParts,
            signPart: signPart,
            abortMultipartUpload: abortMultipartUpload,
            completeMultipartUpload: completeMultipartUpload
        });
        uppy.on("file-added", onFileAddedEvent);
        uppy.on("file-removed", onFileRemovedEvent);
        uppy.on("upload", onUploadEvent);
        uppy.on("upload-success", onUploadSuccessEvent);
        uppy.on("complete", onCompleteEvent);
        return function() {
            uppy.off("file-added", onFileAddedEvent);
            uppy.off("file-removed", onFileRemovedEvent);
            uppy.off("upload", onUploadEvent);
            uppy.off("upload-success", onUploadSuccessEvent);
            uppy.off("complete", onCompleteEvent);
            uppy.cancelAll();
            uppy.clearUploadedFiles();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (!isAuthenticated || !userId) return;
        if (!materialId) {
            (0,_async_to_generator/* default */.Z)(function() {
                var response, contextId, e, ref, status, data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            contextId = self.crypto.randomUUID();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                apiGet("/upload", {
                                    params: {
                                        userId: userId,
                                        contextId: contextId
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            (0,errorLib/* onError */.q)(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            ref = response === null || response === void 0 ? void 0 : response.data, status = ref.status, data = ref.data;
                            if (status == "success") {
                                console.log("New materialId:", data.materialId, "contextId:", contextId);
                                setMaterialId(data.materialId);
                            } else {
                                showAlert({
                                    status: "error",
                                    message: "An error occurred while preparing for upload"
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }, [
        apiGet,
        isAuthenticated,
        materialId,
        setMaterialId,
        showAlert,
        userId
    ]);
    var fileFormatList = allowedFileTypes[scanType].map(function(type) {
        return type.replace(/^\./, "");
    }).join(", ");
    (0,react.useEffect)(function() {
        setUploadComplete(uploadMethod === UploadMethod.UPPY && uppyUploadComplete || uploadMethod === UploadMethod.WE_TRANSFER && isValidWeTransferLink(uploadLinks[uploadMethod]) || uploadMethod === UploadMethod.S3 && isValidS3Link(userItem, uploadLinks[uploadMethod]) && (processWholeBucket && isValidS3BucketLink(userItem, uploadLinks[uploadMethod]) || !processWholeBucket && isValidS3PathLink(userItem, uploadLinks[uploadMethod])));
    }, [
        processWholeBucket,
        setUploadComplete,
        uploadLinks,
        uploadMethod,
        uppyUploadComplete,
        userItem
    ]);
    (0,react.useEffect)(function() {
        if (!uploadPathsLoaded && (userItem === null || userItem === void 0 ? void 0 : userItem.uploadPaths)) {
            var s3UploadLinkInitial = userItem.uploadPaths[0];
            s3UploadLinkInitial = s3UploadLinkInitial.endsWith("/") ? s3UploadLinkInitial : s3UploadLinkInitial + "/";
            setUploadLinks((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploadLinks), (0,_define_property/* default */.Z)({}, UploadMethod.S3, s3UploadLinkInitial)));
            setUploadPathsLoaded(true);
        }
    }, [
        setUploadLinks,
        uploadLinks,
        uploadPathsLoaded,
        userItem
    ]);
    var collator = new Intl.Collator(undefined, {
        sensitivity: "base"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                materialId && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                        className: classes.uploadPanel,
                        elevation: 0,
                        variant: "outlined",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                                position: "static",
                                className: classes.tabs,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                    classes: {
                                        indicator: classes.indicator
                                    },
                                    value: uploadMethod,
                                    onChange: function(event, newValue) {
                                        setUploadMethod(newValue);
                                    },
                                    indicatorColor: "secondary",
                                    textColor: "secondary",
                                    variant: "fullWidth",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: "Upload files direct from your computer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                value: UploadMethod.UPPY,
                                                className: classes.tab,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerSharp/* default */.Z, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: "Batch upload files via WeTransfer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                value: UploadMethod.WE_TRANSFER,
                                                className: classes.tab,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WeTransferIcon */.OR, {}),
                                                disabled: hasUppyUploadStarted
                                            })
                                        }),
                                        (userItem === null || userItem === void 0 ? void 0 : userItem.uploadPaths) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: "Batch upload files via S3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                value: UploadMethod.S3,
                                                className: classes.tab,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* S3Icon */.kp, {}),
                                                disabled: hasUppyUploadStarted
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                                value: uploadMethod,
                                index: UploadMethod.UPPY,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    container: true,
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            xs: scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? 12 : 6,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Dashboard */.A, {
                                                    uppy: uppy,
                                                    showLinkToFileUploadResult: false,
                                                    showProgressDetails: true,
                                                    doneButtonHandler: null,
                                                    proudlyDisplayPoweredByUppy: false,
                                                    disableThumbnailGenerator: scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN,
                                                    width: "100%",
                                                    height: "40vh"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                                                    children: ".uppy-Dashboard-inner {\n                        z-index: 0 !important\n                    }"
                                                })
                                            ]
                                        }),
                                        scanType === metadataLib/* ScanType.TEXTURE_IMPORT */.pv.TEXTURE_IMPORT && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                container: true,
                                                className: classes.textureTypes,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 8,
                                                        className: classes.textureTypesHeadings,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: "Filename"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 4,
                                                        className: classes.textureTypesHeadings,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: "Texture type"
                                                            })
                                                        })
                                                    }),
                                                    (0,_to_consumable_array/* default */.Z)(importFilenames.items).sort(collator.compare).map(function(param, index) {
                                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), filename = _param[0], mapType = _param[1];
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 8,
                                                                    className: classes.filename,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        children: filename
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 4,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                                        select: true,
                                                                        value: mapType,
                                                                        error: !mapType || duplicateMapTypes.includes(mapType),
                                                                        onChange: function(event) {
                                                                            return updateImportFilenames(filename, event.target.value);
                                                                        },
                                                                        children: formatLib/* AllTextureTypes.map */.eD.map(function(name) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                                                value: name,
                                                                                children: name
                                                                            }, name);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, index);
                                                    }),
                                                    mapTypeErrors && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        className: classes.errorMargin,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            color: "error",
                                                            component: "div",
                                                            children: mapTypeErrors.map(function(error) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: error
                                                                }, error);
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                                value: uploadMethod,
                                index: UploadMethod.WE_TRANSFER,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    height: "25em",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        component: "span",
                                        children: [
                                            "You can upload multiple ",
                                            scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scans" : "materials",
                                            " using ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://bandicoot.wetransfer.com",
                                                target: "_blank",
                                                children: "WeTransfer"
                                            }),
                                            ":",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            "Organise your ",
                                                            scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "photos" : "materials",
                                                            " into folders, with a single ",
                                                            scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scan" : "set of texture images",
                                                            " in each folder"
                                                        ]
                                                    }, "1"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            "Go to the ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://bandicoot.wetransfer.com",
                                                                target: "_blank",
                                                                children: "Bandicoot WeTransfer page"
                                                            }),
                                                            " and drag in your ",
                                                            scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scan" : "texture",
                                                            " folders (up to 200 GB per transfer)"
                                                        ]
                                                    }, "2"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Get a link and then come back to this page and paste it in here"
                                                    }, "3")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                container: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        variant: "filled",
                                                        fullWidth: true,
                                                        margin: "normal",
                                                        label: "WeTransfer link",
                                                        onChange: function(e) {
                                                            return setUploadLinks((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploadLinks), (0,_define_property/* default */.Z)({}, uploadMethod, e.target.value)));
                                                        },
                                                        value: uploadLinks[uploadMethod],
                                                        required: true
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            (userItem === null || userItem === void 0 ? void 0 : userItem.uploadPaths) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                                value: uploadMethod,
                                index: UploadMethod.S3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    height: "25em",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            component: "span",
                                            children: [
                                                "You can upload multiple ",
                                                scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scans" : "materials",
                                                " using S3:",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                "Organise your ",
                                                                scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "photos" : "materials",
                                                                " into folders, with a single ",
                                                                scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scan" : "set of texture images",
                                                                " in each folder"
                                                            ]
                                                        }, "1"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Add a new batch folder on AWS S3 using details supplied by Bandicoot"
                                                        }, "2"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                "Upload your ",
                                                                scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scan" : "texture",
                                                                " folders into the batch folder on AWS S3"
                                                            ]
                                                        }, "3"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Copy the S3 path to the batch folder then come back to this page and paste it in here"
                                                        }, "4")
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            container: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    variant: "filled",
                                                    fullWidth: true,
                                                    margin: "normal",
                                                    label: "S3 path",
                                                    onChange: function(e) {
                                                        return setUploadLinks((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploadLinks), (0,_define_property/* default */.Z)({}, uploadMethod, e.target.value)));
                                                    },
                                                    value: uploadLinks[uploadMethod],
                                                    required: true
                                                })
                                            })
                                        }),
                                        isValidS3BucketLink(userItem, uploadLinks[uploadMethod]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                checked: processWholeBucket,
                                                onChange: function(e) {
                                                    return setProcessWholeBucket(e.target.checked);
                                                },
                                                inputProps: {
                                                    "aria-label": "primary checkbox"
                                                },
                                                color: "primary",
                                                disabled: !isValidS3BucketLink(userItem, uploadLinks[uploadMethod])
                                            }),
                                            label: "Process all " + (scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? "scans" : "materials") + " in bucket"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.captionDiv,
                    children: scanType === metadataLib/* ScanType.CAMERA_SCAN */.pv.CAMERA_SCAN ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "caption",
                            children: [
                                "Camera RAW files only (",
                                fileFormatList,
                                "). To use a different RAW format,",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.bandicootimaging.com/contact/contact",
                                    className: classes.captionEmailText,
                                    children: "contact us"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        children: "PNG, JPG, EXR or TIFF texture images"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_PhotoUpload = (PhotoUpload);


/***/ }),

/***/ 25170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProcessingIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21849);
/* harmony import */ var _material_ui_icons_TimerSharp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10587);




var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        processingIcon: {
            color: theme.palette.secondary.light,
            width: "20px",
            height: "20px"
        }
    };
});
function ProcessingIcon() {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_TimerSharp__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classes.processingIcon
    });
}


/***/ }),

/***/ 27419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74098);





function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            p: 3,
            children: children
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (TabPanel);


/***/ }),

/***/ 62260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useUploads; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59072);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15767);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95682);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30014);
/* harmony import */ var _axiosApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86156);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74216);







function useUploads(userId, uploadId, daysSince, allPending, refreshInterval) {
    var ref = (0,_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)(), user = ref.user, isAuthenticated = ref.isAuthenticated;
    var apiGet = (0,_axiosApi__WEBPACK_IMPORTED_MODULE_1__/* .useAxios */ .b)().apiGet;
    // If userId is not specified, use the current user.
    var userIdQuery = userId !== null && userId !== void 0 ? userId : user === null || user === void 0 ? void 0 : user.sub;
    var fromDate = null;
    if (daysSince) {
        fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - daysSince);
        // Round date down to nearest day to avoid unnecessary cache misses
        fromDate.setHours(0, 0, 0, 0);
    }
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(isAuthenticated && userIdQuery ? [
        "/batch/upload",
        {
            params: {
                userId: userIdQuery,
                uploadId: uploadId,
                fromDate: fromDate,
                allPending: allPending
            }
        }
    ] : null, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
            var _param, path, config, ref, ref1, response, ref2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), path = _param[0], config = _param[1];
                        return [
                            4,
                            apiGet(path, config)
                        ];
                    case 1:
                        response = _state.sent();
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.status) !== "success") {
                            ;
                            throw new Error((ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.message);
                        }
                        return [
                            2,
                            (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        refreshInterval: refreshInterval
    }), uploadItems = ref1.data, error = ref1.error;
    var uploadsComplete = uploadItems && uploadItems.reduce(function(acc, cur) {
        if (cur.status === "complete" || cur.status === "invalid") {
            return acc + 1;
        } else {
            return acc;
        }
    }, 0);
    var uploadsPending = uploadItems && uploadItems.length - uploadsComplete;
    return {
        uploadItems: uploadItems,
        uploadsPending: uploadsPending,
        uploadsComplete: uploadsComplete,
        error: error
    };
}


/***/ })

}]);